<div class="card">
    <div class="card-body">
        <h4 class="card-title">Editar preguntas AllPort</h4>
        <br>
        <h5>Parte I</h5>
        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column">Editar/Eliminar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions1; index as i">
                    <td>{{question.index}}</td>
                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                
                    </td>
                </tr>
  
            </tbody>
     
        </table>
        <br>
        <h5>Parte 2</h5>
        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column">Editar/Eliminar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions2; index as i">
                    <td>{{question.index}}</td>
                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                
                    </td>
                </tr>
            </tbody>
     
        </table>
    </div>
</div>

<div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-lg p-20">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">AllPort</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
                <form [formGroup]="allPortForm" (ngSubmit)="update()">
                    <div class="row">
                        <div class="col-md-6">
                            <div  >
                                <label class="control-label">Parte del formulario</label>
                                <select formControlName="part" (change)="setSelectedPart($event)" class="form-control custom-select">
                                    <option selected value="1">Primera</option>
                                    <option value="2">Segunda</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div  class="form-body">
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                            </div>
                            <!--/span-->
                            <div class="row col-md-12" formGroupName="opcA">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción A</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div  >
                                        <label class="control-label">Factor</label>
                                        <select formControlName="factor" class="form-control custom-select">
                                            <option value="teorico">Teórico</option>
                                            <option value="economico">Económico</option>
                                            <option value="estetico">Estético</option>
                                            <option value="social">Social</option>
                                            <option value="politico">Político</option>
                                            <option value="religioso">Religioso</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row col-md-12" formGroupName="opcB">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción B</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div  >
                                        <label class="control-label">Factor</label>
                                        <select formControlName="factor" class="form-control custom-select">
                                            <option value="teorico">Teórico</option>
                                            <option value="economico">Económico</option>
                                            <option value="estetico">Estético</option>
                                            <option value="social">Social</option>
                                            <option value="politico">Político</option>
                                            <option value="religioso">Religioso</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row col-md-12" *ngIf="selectedPart=='2'" formGroupName="opcC">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción C</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div  >
                                        <label class="control-label">Factor</label>
                                        <select formControlName="factor" class="form-control custom-select">
                                            <option value="teorico">Teórico</option>
                                            <option value="economico">Económico</option>
                                            <option value="estetico">Estético</option>
                                            <option value="social">Social</option>
                                            <option value="politico">Político</option>
                                            <option value="religioso">Religioso</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row col-md-12" *ngIf="selectedPart=='2'" formGroupName="opcD">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción D</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div  >
                                        <label class="control-label">Factor</label>
                                        <select formControlName="factor" class="form-control custom-select">
                                            <option value="teorico">Teórico</option>
                                            <option value="economico">Económico</option>
                                            <option value="estetico">Estético</option>
                                            <option value="social">Social</option>
                                            <option value="politico">Político</option>
                                            <option value="religioso">Religioso</option>
                                        </select>
                                    </div>
                                </div>
                                
                            </div>
                            
                        </div>
                        
                        
                    </div>
                    <div class="row">

                        <div class="col-md-6">    
                            <div class="form-group">
                                <label class="control-label">Ìndice</label>
                                <input formControlName="index" type="number" class="form-control" placeholder="Índice">
                            </div>
                        </div>
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Update</button>
                    </div>
                </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

